import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable, of } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { CultureMapService, type UnpaginatedCulturalOfferingListResponse } from '@ui/shared/util-api';
import { CultureMapItemModel } from '../../entities/culture-map-item.model';
import type { CultureMapFilter } from '../../types/culture-map-filters';
import { CulturalOfferingMapper } from '../../mappers/cultural-offering-mapper';
import { CulturalKindMapper } from '../../mappers/cultural-kind-mapper';

@Injectable({ providedIn: 'root' })
export class OfferingMapDataService extends MapDataService<CultureMapItemModel, CultureMapFilter> {
    protected _api = inject(CultureMapService);

    public getData$({
                        search,
                        ageGroups,
                        experienceType,
                        categories,
                        kind,
                    }: CultureMapFilter): Observable<Array<CultureMapItemModel>> {
        if (!CulturalKindMapper.isFilterOfferings(kind as string)) {
            return of([]);
        }

        return this._api.getAllCulturalOfferings({
            titleContains: typeof search === 'string' ? search : undefined,
            targetGroupId: typeof ageGroups === 'number' ? ageGroups : undefined,
            cultureCategoryId: typeof categories === 'number' ? categories : undefined,
            cultureExperienceTypeId: typeof experienceType === 'number' ? experienceType : undefined,
        }).pipe(
            map(offerings => this._mapOfferingsToMapItems(offerings)),
        );
    }

    protected _mapOfferingsToMapItems(listResponse: UnpaginatedCulturalOfferingListResponse): Array<CultureMapItemModel> {
        return listResponse.data.map(offering => CulturalOfferingMapper.fromDto(offering));
    }
}
